import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { EntityTypes } from '@models/enums/EntityTypes';
import { ActivityLogGridComponent } from '@shared/activity-log-grid/activity-log-grid.component';

@Component({
    selector: 'app-opportunities-single-activity-log',
    templateUrl: './opportunities-single-activity-log.component.html',
    styleUrls: ['./opportunities-single-activity-log.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ActivityLogGridComponent]
})
export class OpportunitiesSingleActivityLogComponent {
    opportunityId = input<number | undefined>(undefined);
    entityType: number = EntityTypes.Opportunity;
}
